
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/company",
      function () {
        return require("private-next-pages/en/company/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/company"])
      });
    }
  